var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabPresetCat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "-3 -3 32 32",
    fill: "#B3B3B3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_1980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.6 0 0 5.6 0 12.5C0 19.4 5.6 25 12.5 25C19.4 25 25 19.4 25 12.5C25 5.6 19.4 0 12.5 0ZM12.5 2.5C17.6 2.5 21.8125 6.3125 22.425 11.25H17.35C16.7875 9.0875 14.825 7.5 12.5 7.5C10.175 7.5 8.2125 9.0875 7.6625 11.25H2.575C3.1875 6.3125 7.4 2.5 12.5 2.5ZM15 12.5C15 13.875 13.875 15 12.5 15C11.125 15 10 13.875 10 12.5C10 11.125 11.125 10 12.5 10C13.875 10 15 11.125 15 12.5ZM12.5 22.5C7.4 22.5 3.1875 18.6875 2.575 13.75H7.65C8.2 15.9125 10.1625 17.5 12.4875 17.5C14.8125 17.5 16.775 15.9125 17.325 13.75H22.4C21.8125 18.6875 17.6 22.5 12.5 22.5V22.5Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.4989 1.6666C17.5989 1.6666 22.9165 6.24999 23.3332 11.6667H16.6665C16.104 9.50416 14.8248 7.91666 12.4998 7.91666C10.1748 7.91666 8.88317 9.50416 8.33317 11.6667H1.6665C2.08317 5.83333 7.39889 1.6666 12.4989 1.6666Z",
    fill: "#B3B3B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_1980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabPresetCat);
export default __webpack_public_path__ + "static/media/tab_preset_cat.e48f4cfa6d3fea284ba39fb6557a094a.svg";
export { ForwardRef as ReactComponent };